<template>
  <div>
    <!-- 用户列表 账号管理 -->
    <div class="layout" :class="{'system-setting-layout': asCom}" v-if="pageType==='systemSettings'">
      <div class="system-setting">
        <div class="layout-header" ref="systemSettings">
          <div class="infor-layout-header mb20">
            <span class="title">账号管理</span>
          </div>
          <w-searchs @onRole="onRole" @onAdd="onAdd" @onAudit="onAudit" @onSearch="onSearch" :roleIdList="roleIdListAll"/>
        </div>
        <div style="height:8.5625rem;"></div>
        <div class="m16 pagination-bg-white table-container" style="padding: 0 1rem;">
          <w-table
            :height="tableViewHeight"
            v-show="checkUserAuth(6, 32)"
            v-loading.body="tableLoading"
            :data-list="tableData"
            :columns="staticData.users.columns"
            :pageNo="formData.pageNum"
            :pageSize="formData.pageSize"
            :total="total"
            @pageNoChange="pageNoChange"
            @pageSizeChange="pageSizeChange"
            >
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
              <span v-if="props.column.label === '单车类型'">{{handleBikeType(props.row.bikeType)}}</span>
              <span v-else-if="props.column.label === '联系电话'">
                {{ hidePhoneNumber(props.row['phone']) }}
              </span>
              <span v-else-if="props.column.label === '使用时效'">
                {{ props.row['createTime'] | dateFormat('yyyy-MM-dd')}}
                至
                {{ props.row['unavailableTime'] | dateFormat('yyyy-MM-dd')}}
              </span>
              <span v-else-if="props.column.label === '区域'">
                {{ getAddressNamesForArea(props.row['areaId'], nationalArea) }}
              </span>
              <span v-else-if="props.column.label === '操作'">
                <a @click="onShowDialog(props.row,'textList')" class="table-btn blue" href="#">查看</a>
                <span class="gray">｜</span>
                <el-dropdown @command="handleCommand($event, props.row)">
                  <span class="el-dropdown-link blue">
                    下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command='item.value'
                      v-for="(item,index) in operatesParams"
                      :key="'role'+index">{{item.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
              <span v-else>{{ props.row[props.column.property]}}</span>
            </template>
          </w-table>
          <div v-show="!checkUserAuth(6, 32)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>
    <!-- 角色列表 -->
    <div class="layout" v-if="pageType==='roleSettings'" style="margin-left: 0;z-index: 11;">
      <div class="breadcrumb-box">
        <div class="breadcrumb">
          <span class="first" @click="pageType='systemSettings'">账号管理</span>
          /
          <span class='last'>角色管理</span>
        </div>
        <el-button type="primary" size="mini" @click="pageType='systemSettings'">返回</el-button>
      </div>
      <div class="system-setting">
        <div ref="roleSettings" class="layout-header-100" style="margin:0.9375rem 0.9375rem 0 0.9375rem;">
          <div class="infor-layout-header">
            <span class="title">角色管理</span>
            <p v-show="checkUserAuth(6, 37)">
              <el-button type="primary" size="nimi" @click="addRole">增加角色</el-button>
            </p>
          </div>
        </div>
        <div style="height:6.5rem;"></div>

        <div class="m16 pagination-bg-white">
          <w-table
            :height="tableViewHeight"
            v-loading.body="tableLoading"
            :data-list="roleIdList"
            :columns="staticData.roles.columns"
            :pageNo="formDataRole.pageNum"
            :pageSize="formDataRole.pageSize"
            :total="totalRole"
            @pageNoChange="pageNoChangeRole"
            @pageSizeChange="pageSizeChangeRole"
            >
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formDataRole.pageNum - 1) * formDataRole.pageSize}}</span>
              <span v-if="props.column.label === '是否需要审核'">
                {{ props.row['isAudit'] === 1?'需要':'不需要' }}
              </span>
              <span v-else-if="props.column.label === '操作'">
                <a v-show="checkUserAuth(6, 38)" @click="onShowDialog(props.row,'editRole')" class="table-btn blue" href="#">编辑</a>
                <template v-show="checkUserAuth(6, 39)">
                  <span class="gray">｜</span>
                  <a @click="delRole(props.row)" class="table-btn blue" href="#">删除</a>
                </template>
              </span>
              <span v-else>{{ props.row[props.column.property]}}</span>
            </template>
          </w-table>
        </div>
      </div>
    </div>
    <!-- 审核列表 -->
    <div class="layout" :class="{'system-setting-layout': asCom}" v-if="pageType==='auditListSettings'">
      <div class="breadcrumb-box">
        <div class="breadcrumb">
          <span class="first" @click="pageType='systemSettings'">账号管理</span>
          /
          <span class='last'>审核列表</span>
        </div>
        <el-button type="primary" size="mini" @click="pageType='systemSettings'">返回</el-button>
      </div>
      <div class="system-setting">
        <div ref="auditListSettings" class="layout-header" style="margin:1rem;">
          <div class="infor-layout-header mb20">
            <span class="title">审核列表</span>
          </div>
          <w-searchs searchType="auditList" @onRole="onRole" @onAdd="onAdd" @onAudit="onAudit" @onSearch="onSearch" :auditRoleIdList="auditRoleIdAll"/>
        </div>
        <div style="height:9.625rem;"></div>

        <div class="m16 pagination-bg-white table-container">
          <w-table
            :height="tableViewHeight"
            v-loading.body="tableLoading"
            :data-list="auditTableData"
            :columns="staticData.audit.columns"
            :pageNo="formDataAudit.pageNum"
            :pageSize="formDataAudit.pageSize"
            :total="totalAudit"
            @pageNoChange="pageNoChange"
            @pageSizeChange="pageSizeChange"
            >
            <template slot-scope="props" slot="cell">
              <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formDataAudit.pageNum - 1) * formDataAudit.pageSize}}</span>
              <span v-if="props.column.label === '单车类型'">{{handleBikeType(props.row.bikeType)}}</span>
              <span v-else-if="props.column.label === '使用时效'">
                {{ props.row['createTime'] | dateFormat('yyyy-MM-dd')}}
                至
                {{ props.row['unavailableTime'] | dateFormat('yyyy-MM-dd')}}
              </span>
              <span v-else-if="props.column.label === '审核状态'" :class="{red: props.row.status === 2, green: props.row.status === 1}">
                {{getAuditStatus(props.row.status)}}
              </span>
              <span v-else-if="props.column.label === '操作'">
                <el-button v-show="checkUserAuth(6, 34)" v-if="props.row.status === 0" size="mini" type="primary" @click="onShowDialog(props.row, 'textList', 'auditEdit')">审核</el-button>
                <a v-if="props.row.status !== 0" @click="onShowDialog(props.row,'textList','show')" class="table-btn blue" href="#">查看</a>
              </span>
              <span v-else>{{ props.row[props.column.property]}}</span>
            </template>
          </w-table>
        </div>
      </div>
    </div>

    <w-dialog
      ref="w-dialog"
      :title="dialogTitle"
      :width="dialogWidth"
      :sureBtnText="sureBtnText"
      :cancelBtnText="cancelButtonText"
      :isShowFooter="isShowFooter"
      :btnLoading="btnLoading"
      @handleClose="handleClose"
      @handleCloseRight="handleCloseRight"
      @onSure="onSure">
        <template v-slot:content>
          <div class="dialog-content">
            <!-- 用户查看 -->
            <template v-if="type==='textList'">
              <text-list-slot>
                <ul>
                  <li>
                    <span>登录账号：</span>
                    <span>{{detail.username}}</span>
                  </li>
                  <li>
                    <span>姓名：</span>
                    <span>{{detail.name}}</span>
                  </li>
                  <li>
                    <span>联系电话：</span>
                    <span>{{hidePhoneNumber(detail.phone)}}</span>
                  </li>
                  <li>
                    <span>工作单位：</span>
                    <span>{{detail.company}}</span>
                  </li>
                  <li>
                    <span>单车类型：</span>
                    <span>{{handleBikeType(detail.bikeType)}}</span>
                  </li>
                </ul>
                <ul>
                  <li>
                    <span>角色类型：</span>
                    <span>{{detail.roleName}}</span>
                  </li>
                  <li>
                    <span>权限区域：</span>
                    <span>{{detail.addressText}}</span>
                  </li>
                  <li>
                    <span>使用时效：</span>
                    <span>{{detail.createTime | dateFormat('yyyy-MM-dd')}}至{{detail.unavailableTime | dateFormat('yyyy-MM-dd')}}</span>
                  </li>
                  <li class="mt10">
                    <span style="vertical-align: top;">身份证照：</span>
                    <span v-if="detail.idcardUrl">
                      <el-image
                        style="width: 6.25rem; height: 6.25rem;margin-right:0.625rem;"
                        :src="detail.idcardUrl | filterImage"
                        :preview-src-list="[filterImage(detail.idcardUrl),filterImage(detail.idcardBackUrl)]">
                      </el-image>
                    </span>
                    <span v-else>
                      <el-image
                        style="width: 6.25rem; height: 6.25rem;margin-right:0.625rem;"
                        :src="require('@/assets/zanwu.png')">
                      </el-image>
                    </span>
                  <span v-if="detail.idcardBackUrl">
                      <el-image
                        style="width: 6.25rem; height: 6.25rem"
                        :src="detail.idcardBackUrl | filterImage"
                        :preview-src-list="[filterImage(detail.idcardBackUrl), filterImage(detail.idcardUrl)]">
                      </el-image>
                    </span>
                    <span v-else>
                      <el-image
                        style="width: 6.25rem; height: 6.25rem;margin-right:0.625rem;"
                        :src="require('@/assets/zanwu.png')">
                      </el-image>
                    </span>
                  </li>
                </ul>
                <ul>
                  <li v-if="pageType === 'auditListSettings'">
                    <span>审核状态：</span>
                    <span>{{getAuditStatus(detail.status)}}</span>
                  </li>
                  <li v-if="pageType !== 'auditListSettings'">
                    <span>创建人：</span>
                    <span>{{detail.createUserName}}</span>
                  </li>
                  <li>
                    <span>角色类型：</span>
                    <span>{{detail.roleName}}</span>
                  </li>
                  <li v-if="pageType === 'auditListSettings'">
                    <span>创建人：</span>
                    <span>{{detail.createBy}}</span>
                  </li>
                  <li>
                    <span>创建时间：</span>
                    <span>{{detail.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
                  </li>
                  <li v-if="pageType === 'auditListSettings'&& detail.updateTime">
                    <span>审核人：</span>
                    <span>{{detail.updateBy}}</span>
                  </li>
                  <li v-if="pageType === 'auditListSettings' && detail.updateTime">
                    <span>审核时间：</span>
                    <span>{{detail.updateTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
                  </li>
                  <li v-if="pageType === 'auditListSettings' && detail.reason">
                    <span>拒绝原因：</span>
                    <span>{{detail.reason}}</span>
                  </li>
                </ul>
              </text-list-slot>
            </template>
            <!-- 用户编辑 添加账号 -->
            <template v-if="['edit','add'].includes(type)">
              <el-form :model="form" :rules="rules" ref="ruleForm" label-width="6.25rem" class="demo-ruleForm" size="small">
                <el-form-item label="登录账号：" prop="userName">
                  <el-input v-model="form.userName" placeholder="请填写" style="width:50%;"></el-input>
                  <span style="margin-left:0.5rem;font-size:0.5rem;color:rgba(0,0,0,0.25);">注：账号均为小写字母或数字</span>
                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                  <el-input v-model="form.name" placeholder="请填写" style="width:50%;"></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="phone">
                  <el-input v-model="form.phone" placeholder="请填写" maxlength="11" style="width:50%;"></el-input>
                </el-form-item>
                <el-form-item label="工作单位：" prop="company">
                  <el-input v-model="form.company" placeholder="请填写" style="width:50%;"></el-input>
                </el-form-item>
                <el-form-item label="单车类型：" prop="bikeType">
                  <el-select v-model="form.bikeType"  @change="filterBikeTypeList" size="small" placeholder="请选择用户类型" style="width:50%;">
                    <el-option :label="item.name" :value="item.userType" v-for="(item,index) in bikeTypeList" :key="'userType'+index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="角色类型：" prop="roleId">
                  <el-select @change="changeRoleId" v-model="form.roleId" size="small" placeholder="请选择" style="width:50%;">
                    <el-option :label="item.name" :value="item.id" v-for="(item,index) in addRoleIdAll" :key="'roleId'+index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="权限区域：" prop="areaId">
                  <w-areaid v-model="form.areaId" :detail="detail" placeholder="请填写"></w-areaid>
                </el-form-item>
                <el-form-item label="使用时效：" prop="unavailableTime">
                  <el-date-picker
                    v-model="form.unavailableTime"
                    type="datetime"
                    placeholder="选择截止日期"
                    default-time="23:59:59"
                    :picker-options="timePickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="身份证照：" prop="idcard">
                  <el-upload
                    style="display:inline-block;margin-right:0.625rem;"
                    class="avatar-uploader"
                    :action="'/api/upload/commonUpload?selfAreaId='+selfAreaId"
                    :data="{type: 'id_front_card'}"
                    :headers="{Authorization:authorization}"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    :on-remove="handleRemove"
                    :on-preview="handlePictureCardPreview">
                    <img v-if="form.idcardUrl" :src="form.idcardUrl  | filterImage" class="avatar">
                    <template v-else>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <span class="avatar-uploader-text">头像面</span>
                    </template>
                  </el-upload>
                  <el-upload
                    style="display:inline-block;"
                    class="avatar-uploader"
                    :action="'/api/upload/commonUpload?selfAreaId='+selfAreaId"
                    :data="{type: 'id_back_card'}"
                    :headers="{Authorization:authorization}"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                    :before-upload="beforeAvatarUpload"
                    :on-remove="handleRemove2"
                    :on-preview="handlePictureCardPreview">
                    <img v-if="form.idcardBackUrl" :src="form.idcardBackUrl | filterImage" class="avatar">
                    <template v-else>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                      <span class="avatar-uploader-text">国徽面</span>
                    </template>
                  </el-upload>
                </el-form-item>
              </el-form>
            </template>
            <!-- 角色编辑 -->
            <template v-if="['editRole','addRole','rolePromission'].includes(type)">
              <el-form :model="formRole" :rules="rulesRole" ref="roleForm" label-width="6.25rem" class="demo-ruleForm" size="small">
                <el-form-item label="角色：" prop="name">
                  <el-input :disabled="type==='rolePromission'" v-model="formRole.name" placeholder="请填写" style="width:50%;"></el-input>
                </el-form-item>
                <el-form-item label="角色等级：" prop="level">
                  <el-select @change="changeRoleId" v-model="formRole.level" size="small" placeholder="请选择" style="width:50%;">
                    <el-option  v-for="n in 5"
                                :key="`level-${n}`"
                                :label="`${['一','二','三','四','五'][n - 1]}级`"
                                :value="n"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="描述：" prop="description">
                  <el-input :disabled="type==='rolePromission'" v-model="formRole.description"  type="textarea" :rows="6" placeholder="请填写" style="width:50%;"></el-input>
                </el-form-item>
                <el-form-item label="" prop="isAudit">
                  <el-checkbox :disabled="type==='rolePromission'" v-model="formRole.isAudit">是否需要系统管理员审核</el-checkbox>
                </el-form-item>
                <template v-if="permissions && permissions.length">
                  <el-form-item :label="permissions[0].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate0" v-model="checkAll0" @change="handleCheckAllChange($event,0)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-0']" @change="handleCheckedCitiesChange($event,0)">
                      <el-checkbox v-for="it in permissions[0].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="permissions[1].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate1" v-model="checkAll1" @change="handleCheckAllChange($event,1)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-1']" @change="handleCheckedCitiesChange($event,1)">
                      <el-checkbox v-for="it in permissions[1].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="permissions[2].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate2" v-model="checkAll2" @change="handleCheckAllChange($event,2)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-2']" @change="handleCheckedCitiesChange($event,2)">
                      <el-checkbox v-for="it in permissions[2].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="permissions[3].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate3" v-model="checkAll3" @change="handleCheckAllChange($event,3)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-3']" @change="handleCheckedCitiesChange($event,3)">
                      <el-checkbox v-for="it in permissions[3].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="permissions[4].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate4" v-model="checkAll4" @change="handleCheckAllChange($event,4)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-4']" @change="handleCheckedCitiesChange($event,4)">
                      <el-checkbox v-for="it in permissions[4].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="permissions[5].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate5" v-model="checkAll5" @change="handleCheckAllChange($event,5)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-5']" @change="handleCheckedCitiesChange($event,5)">
                      <el-checkbox v-for="it in permissions[5].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="permissions[6].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate6" v-model="checkAll6" @change="handleCheckAllChange($event,6)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-6']" @change="handleCheckedCitiesChange($event,6)">
                      <el-checkbox v-for="it in permissions[6].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="permissions[7].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate7" v-model="checkAll7" @change="handleCheckAllChange($event,7)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-7']" @change="handleCheckedCitiesChange($event,7)">
                      <el-checkbox v-for="it in permissions[7].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                   <el-form-item :label="permissions[8].permission.name">
                    <el-checkbox :indeterminate="isIndeterminate7" v-model="checkAll8" @change="handleCheckAllChange($event,8)">全选</el-checkbox>
                    <el-checkbox-group v-model="formRole['role-8']" @change="handleCheckedCitiesChange($event,8)">
                      <el-checkbox v-for="it in permissions[8].child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </template>
                <!-- <template v-for="(item,index) in permissions">
                  <el-form-item :label="item.permission.name" :key="'role'+index">
                    <template v-if="item && item.child && item.child.length">
                      <el-checkbox :indeterminate="'isIndeterminate'+index" v-model="formRole['checkAll'+index]" @change="handleCheckAllChange($event,index)">全选</el-checkbox>
                      <el-checkbox-group v-model="formRole['role-'+index]" @change="handleCheckedCitiesChange($event,index)">
                        <el-checkbox v-for="it in item.child" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
                      </el-checkbox-group>
                    </template>
                  </el-form-item>
                </template> -->
              </el-form>
            </template>
          </div>
        </template>
    </w-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import WDialog from '@/components/Model/index.vue'
import WTable from '@/components/Table/index.vue'
import WSearchs from '@/components/Searchs/index.vue'
import staticData from './staticData.js'
import Api from '@/api'
import { mapGetters } from 'vuex'
import { operates } from '@/utils/const'
import { getFilterParams, filterImage, getAddressNamesForArea } from '@/utils/tools'
import TextListSlot from '@/components/Listbox/textListSlot.vue'
import WAreaid from '@/components/Form/w-areaid-company'
import WUpload from '@/components/Update'
import validate from '@/utils/validate'
import NoPermission from '@/views/Other/401.vue'
import store from '@/store'

export default {
  name: 'systemSettings',
  props: {
    asCom: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WDialog,
    WTable,
    WSearchs,
    TextListSlot,
    WAreaid,
    WUpload,
    NoPermission
  },
  data() {
    return {
      btnLoading: false,
      operatesParams: [],
      isIndeterminate0: true,
      isIndeterminate1: true,
      isIndeterminate2: true,
      isIndeterminate3: true,
      isIndeterminate4: true,
      isIndeterminate5: true,
      isIndeterminate6: true,
      isIndeterminate7: true,
      isIndeterminate8: true,
      checkAll0: false,
      checkAll1: false,
      checkAll2: false,
      checkAll3: false,
      checkAll4: false,
      checkAll5: false,
      checkAll6: false,
      checkAll7: false,
      checkAll8: false,
      pageType: 'systemSettings',
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      selectRolePromission: [],
      formRole: {
        name: '',
        description: '',
        isAudit: false,
        level: '',
        'role-0': [],
        'role-1': [],
        'role-2': [],
        'role-3': [],
        'role-4': [],
        'role-5': [],
        'role-6': [],
        'role-7': [],
        'role-8': []
      },
      rulesRole: {
        name: [
          { required: true, message: '请填写角色', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择角色等级', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请填写角色描述', trigger: 'blur' }
        ],
        isAudit: [
          { required: true, message: '请选择是否需要系统管理员审核', trigger: 'blur' }
        ]
      },
      formDataRole: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      totalRole: 0,
      tableLoading: false,
      tableData: null, // 用户列表
      auditTableData: null, // 审核列表
      totalAudit: 0,
      formDataAudit: {
        pageNum: 1,
        pageSize: 10
      },
      type: '',
      dialogTitle: '',
      dialogWidth: '45%',
      sureBtnText: '确定',
      cancelButtonText: '取消',
      detail: null,
      roleIdList: [],
      roleIdListAll: [],
      auditRoleIdAll: [],
      addRoleIdAll: [],
      searchData: null,
      form: {
        userName: '',
        name: '',
        phone: '',
        company: '',
        roleId: '',
        areaId: '',
        unavailableTime: '',
        idcardUrl: '',
        idcardBackUrl: '',
        bikeType: ''
      },
      rules: {
        userName: [
          { required: true, message: '请填写登录账号', trigger: 'blur' },
          { min: 6, message: '长度至少6位小写字母', trigger: 'blur' },
          { validator: this.validateUserName.bind(this), trigger: 'blur' },
          { validator: this.validateName.bind(this), trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          { validator: this.validateChineseNumberName.bind(this), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请填写联系电话', trigger: 'blur' },
          { min: 8, message: '长度至少8个字符', trigger: 'blur' },
          {
            pattern: '^1[3456789]\\d{9}$',
            message: '手机号格式不正确',
            trigger: 'blur'
          },
          { validator: this.validatePhone.bind(this), trigger: 'change' }
        ],
        company: [
          { required: true, message: '请填写工作单位', trigger: 'blur' },
          { min: 2, message: '长度至少2个字符', trigger: 'blur' },
          { validator: this.validateCompany.bind(this), trigger: 'blur' }
        ],
        bikeType: [
          { required: true, message: '请选择单车类型', trigger: 'blur' }
        ],
        roleId: [
          { required: true, message: '请选择角色类型', trigger: 'blur' }
        ],
        areaId: [
          { required: true, message: '请选择权限区域', trigger: 'blur' }
        ],
        unavailableTime: [
          { required: true, message: '请选择截止日期', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      dialogImageUrl: '',
      areaIds: [], // 当前省市区
      isShowFooter: true,
      tableViewHeight: '',
      bikeTypeListAll: [{
        userType: 0,
        name: '自行车'
      }, {
        userType: 1,
        name: '电动车'
      }, {
        userType: 2,
        name: '包含自行车和电动车'
      }],
      bikeTypeList: [],
      // 日期选择器配置：限制最大可选时间
      timePickerOptions: {
        disabledDate: (time) => {
          // 最大允许时间：2031年4月30日23:59:59
          const maxTime = new Date('2031-04-30 23:59:59').getTime()
          // 空值合并?? ：如果前面是undefined/null，默认取false
          // 系统管理员（id=1）不禁用（true），其他人禁用（false）
          const isAdmin = this.user?.roles?.[0]?.id === 1 ?? false
          // 禁用所有大于该时间的日期（先过滤日期，时分秒后续校验）
          return isAdmin ? '' : (time.getTime() > maxTime)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'nationalArea',
      'user',
      'selfAreaId',
      'permissions',
      'authorization',
      'userSelfAreaId',
      'globaleSelfAreaId',
      'userCurrentPage',
      'userBikeType']),
    staticData() {
      return staticData
    },
    operates() {
      return operates
    }
  },
  created() {
    if (this.userCurrentPage) {
      this.formData.pageSize = this.userCurrentPage
    }
    if (this.$route.params) {
      if (this.$route.params.audit) {
        this.onAudit()
      }
    }
    this.filterBikeTypeList()
    this.initOperatesParams()
    this.initData()
    this.initRoleAll()
    this.initAuditRoleAll()
    this.initAddRoleAll()
  },
  watch: {
    pageType(v) {
      if (v === 'systemSettings') {
        this.calcView()
      }
    }
  },
  methods: {
    filterBikeTypeList() {
      const { user } = this
      // 1. 获取用户角色ID，做容错处理（防止user/roles为空）
      const roleId = user?.roles?.[0]?.id ?? -1
      // 2. 获取当前已选的单车类型，初始为undefined
      const currentUserBikeType = this.userBikeType
      // 规则1：系统管理员（roleId=1）→ 不设限，显示全部3个选项
      if (roleId === 1) {
        this.bikeTypeList = [...this.bikeTypeListAll]
        return
      }
      // 规则2：超级管理员（roleId=8）→ 按已选类型过滤
      if (roleId === 8 || roleId === 15) {
        switch (currentUserBikeType) {
          // 已选自行车（0）→ 下级只能选自行车
          case 0:
            this.bikeTypeList = this.bikeTypeListAll.filter(item => item.userType === 0)
            break
          // 已选电动车（1）→ 下级只能选电动车
          case 1:
            this.bikeTypeList = this.bikeTypeListAll.filter(item => item.userType === 1)
            break
          // 已选包含两者（2）→ 下级可选自行车/电动车（排除2）
          case 2:
            this.bikeTypeList = this.bikeTypeListAll.filter(item => item.userType !== 2)
            break
          // 初始未选择（undefined）→ 显示全部选项（让用户先选自身属性）
          default:
            this.bikeTypeList = this.bikeTypeListAll.filter(item => item.userType === currentUserBikeType)
        }
      } else {
        // 选择登录账号的本身车辆类型属性
        this.bikeTypeList = this.bikeTypeListAll.filter(item => item.userType === currentUserBikeType)
      }
    },
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs[this.pageType] && this.$refs[this.pageType].clientHeight) {
          H += Number(this.$refs[this.pageType].clientHeight)
        }
        if (['roleSettings', 'auditListSettings'].includes(this.pageType)) {
          H += 60
        }
        // console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        // 56: tab栏 40 + padding 16 修正
        let asComHeight = ''
        if (this.asCom) {
          asComHeight = 56
        }
        this.tableViewHeight = window.innerHeight - 56 - H - 79 - asComHeight
      })
    },
    getAddressNamesForArea(id, list) {
      try {
        return getAddressNamesForArea(id, list, null)
      } catch (err) {
        console.log(err)
      }
    },
    filterImage(url) {
      return filterImage(url)
    },
    initOperatesParams() {
      this.operatesParams = []
      const auth = this.user.auth.find(aut => aut.id === 6)
      if (auth && auth.child && auth.child.length) {
        const child = auth.child
        if (child.some(c => c.id === 50)) {
          this.operatesParams.push({ value: 2, name: '重置密码' })
        }
        if (child.some(c => c.id === 31)) {
          this.operatesParams.push({ value: 3, name: '修改' })
        }
        if (child.some(c => c.id === 45)) {
          this.operatesParams.push({ value: 4, name: '删除' })
        }
      }
    },
    getAuditStatus(status) {
      return status === 0
        ? '待审核'
        : (status === 1
          ? '已通过'
          : (status === 2
            ? '已拒绝'
            : ''))
    },
    handleCheckAllChange(val, index) {
      const p = []
      this.permissions[index].child.forEach(it => {
        p.push(it.id)
      })
      this.formRole['role-' + index] = val ? p : []
      this['isIndeterminate' + index] = false
    },
    handleCheckedCitiesChange(val, index) {
      console.log(val)
      const p = []
      this.permissions[index].child.forEach(it => {
        p.push(it.id)
      })
      console.log(val, index, p)
      const checkedCount = val.length
      this['checkAll' + index] = checkedCount === p.length
      this['isIndeterminate' + index] = checkedCount > 0 && checkedCount < p.length
    },
    delRole(item) {
      const text = `你是否确定删除“${item.name}”？`
      const textTitle = '温馨提示'
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelRole(item)
      }).catch(() => {})
    },
    handleDelRole(item) {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId,
        id: item.id
      }
      const data = {
        id: item.id
      }
      Api.handleDelRole(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('角色删除成功！')
            vm.initRole()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    onRole() {
      this.formDataRole.pageNum = 1
      this.formDataRole.pageSize = 10
      this.initRole()
      this.pageType = 'roleSettings'
    },
    changeRoleId(val) {
      this.$refs.ruleForm.validateField(['userName'], emailError => {
        if (!emailError) {
          console.log('验证通过!')
        } else {
          console.log('验证失败!')
          return false
        }
      })
    },
    addRole() {
      this.onShowDialog(null, 'addRole')
    },
    validateUserName(rule, value, callback) {
      const roleId = this.form.roleId
      const role = this.roleIdListAll.find(r => Number(r.id) === Number(roleId))
      console.log('当前选择的角色', role)
      if (role && ([role.name].indexOf('APP') > -1 || [role.name].indexOf('app') > -1 || [role.name].indexOf('App') > -1)) { // App用户
        if (!validate.checkPhone(value)) {
          callback(new Error('APP用户账号由11位手机号组成'))
        }
      } else {
        if (!validate.checkUppercaseAndNumber(value)) {
          callback(new Error('请输入合法的登录账号'))
        }
      }
      callback()
    },
    // 登录账号
    validateName(rule, value, callback) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        username: vm.form.userName,
        userId: vm.detail && vm.detail.id ? vm.detail.id : 0
      }
      Api.checkUsername(params)
        .then(res => {
          if (res.code === 200) {
            console.log(res)
            if (Number(res.data.existUsername) === 0) {
              callback()
            } else {
              callback(new Error('该姓名已被注册，请重新输入！'))
            }
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    // 姓名
    validateChineseNumberName(rule, value, callback) {
      if (!value) {
        callback(new Error('姓名不能为空'))
      } else if (value.length < 2) {
        callback(new Error('姓名必须中文并不少于2个字符'))
      } else if (!/^[\u4E00-\u9FA5]{2,100}$/.test(value)) {
        callback(new Error('姓名必须中文并不少于2个字符'))
      }
      callback()
    },
    validateCompany(rule, value, callback) {
      // 1. 定义允许的字符范围（宽松但安全）
      const allowedPattern = /^[\u4e00-\u9fa5a-zA-Z0-9\s（）()【】·\-.、，,._\\&]*$/
      if (!allowedPattern.test(value)) {
        return callback(new Error('工作单位包含非法字符'))
      }
      // 2. 黑名单关键词校验
      const invalidKeywords = ['测试', '无', '暂无', '自由职业']
      const foundKeyword = invalidKeywords.find(keyword => value.includes(keyword))
      if (foundKeyword) {
        return callback(new Error(`工作单位不能包含“${foundKeyword}”`))
      }
      // 3. 通过校验
      callback()
    },
    validatePhone(rule, value, callback) {
      console.log(this.form.phone)
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        phone: vm.form.phone,
        userId: vm.detail && vm.detail.id ? vm.detail.id : 0
      }
      Api.checkPhone(params)
        .then(res => {
          if (res.code === 200) {
            console.log(res)
            if (Number(res.data.existPhone) === 0) {
              callback()
            } else {
              callback(new Error('该手机号码已被注册，请输入新号码！'))
            }
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    beforeAvatarUpload(file) {
      const isJPG = ['image/jpeg', 'image/png'].includes(file.type)
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      return isJPG
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file)
      this.form.idcardUrl = res.data.path
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.form.idcardUrl = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleAvatarSuccess2(res, file) {
      console.log(res, file)
      this.form.idcardBackUrl = res.data.path
    },
    handleRemove2(file, fileList) {
      this.form.idcardBackUrl = ''
    },
    handleCommand(command, item) {
      console.log(command, item)
      switch (command) {
        case 2: // 密码重置
          this.reset(item)
          break
        case 3: // 修改
          this.editUser(item)
          break
        case 4: // 删除
          this.delUser(item)
      }
    },
    reset(item) {
      const vm = this
      const text = `你是否确定对“${item.name}”账号进行重置密码？`
      const textTitle = '温馨提示'
      vm.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          selfAreaId: vm.globaleSelfAreaId
        }
        const data = {
          id: item.id
        }
        Api.reset(data, params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('重置密码成功！')
            } else {
              vm.$message.warning(res.message)
            }
          })
      }).catch(() => {})
    },
    editUser(item) {
      this.isShowFooter = true
      this.onShowDialog(item, 'edit')
    },
    delUser(item) {
      const textTitle = '温馨提示'
      const text = '你是否确定删除“' + item.name + '”账号'
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelUser(item)
      }).catch(() => {})
    },
    handleDelUser(item) {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId
      }
      const data = {
        id: item.id,
        status: 2
      }
      Api.banUser(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.initData()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    onSearch(params) {
      console.log('onSearch', params)
      this.searchData = params
      if (this.pageType === 'systemSettings') {
        this.initData()
      } else if (this.pageType === 'auditListSettings') {
        this.initAuditData()
      }
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      let params = {}
      if (this.searchData) {
        params = { ...this.searchData }
      } else {
        params.roleId = 0
      }
      // if (Number(params.roleId) === 0) {
      //   delete params.roleId
      // }
      params.selfAreaId = this.selfAreaId
      params.currentPage = this.formData.pageNum
      params.pageSize = this.formData.pageSize
      params = getFilterParams(params)
      Api.getUserList(params)
        .then(res => {
          if (res.code === 200) {
            vm.tableData = res.data.lists
            vm.total = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
          vm.calcView()
        })
    },
    initAuditData() {
      const vm = this
      vm.tableLoading = true
      let params = {}
      if (this.searchData) {
        params = { ...this.searchData }
      } else {
        // 日常值守-待处理事件中的平台账号申请数
        if (this.$route.params) {
          this.formDataAudit.roleId = this.$route.params.roleId
          this.formDataAudit.status = this.$route.params.status
        } else {
          params.status = 99
        }
      }
      params.selfAreaId = this.selfAreaId
      params.currentPage = this.formDataAudit.pageNum
      params.pageSize = this.formDataAudit.pageSize
      params = getFilterParams(params)
      Api.getAuditList(params)
        .then(res => {
          if (res.code === 200) {
            vm.auditTableData = res.data.list
            vm.totalAudit = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
          vm.calcView()
        })
    },
    initRoleAll() {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId
        // currentPage: this.formDataRole.pageNum,
        // pageSize: this.formDataRole.pageSize
      }
      Api.getRoleAll(params)
        .then(res => {
          if (res.code === 200) {
            vm.roleIdListAll = res.data
            // vm.totalRole = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    initAuditRoleAll() {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.getAuditRoleAll(params)
        .then(res => {
          if (res.code === 200) {
            vm.auditRoleIdAll = res.data
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    initAddRoleAll() {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.getAddRoleAll(params)
        .then(res => {
          if (res.code === 200) {
            vm.addRoleIdAll = res.data
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    initRole() {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formDataRole.pageNum,
        pageSize: this.formDataRole.pageSize
      }
      Api.getRoleList(params)
        .then(res => {
          if (res.code === 200) {
            vm.roleIdList = res.data.lists
            vm.totalRole = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.calcView()
        })
    },
    onAdd() {
      this.onShowDialog(null, 'add')
    },
    onAudit() {
      this.pageType = 'auditListSettings'
      this.formDataAudit.pageNum = 1
      this.formDataAudit.pageSize = 10
      this.totalAudit = 0
      this.initAuditData()
    },
    onShowDialog(item, type, auditType) {
      const vm = this
      vm.detail = item
      vm.type = type
      if (type === 'textList') {
        if (vm.pageType === 'systemSettings') {
          vm.dialogTitle = '账号信息'
          vm.sureBtnText = '确定'
          vm.cancelButtonText = '取消'
          vm.isShowFooter = false
        } else if (vm.pageType === 'auditListSettings') {
          if (auditType === 'auditEdit') {
            vm.dialogTitle = '账号信息'
            vm.sureBtnText = '通过'
            vm.cancelButtonText = '拒绝'
            vm.isShowFooter = true
          } else {
            vm.isShowFooter = false
          }
        }
        const params = {
          areaId: vm.detail.areaId,
          selfAreaId: vm.selfAreaId
        }
        Api.getUserArea(params)
          .then(res => {
            if (res.code === 200) {
              vm.detail.addressText = ''
              if (res.data.province && res.data.province.areaName) {
                vm.detail.addressText += res.data.province.areaName
              }
              if (res.data.city && res.data.city.areaName) {
                vm.detail.addressText += res.data.city.areaName
              }
              if (res.data.region && res.data.region.areaName) {
                vm.detail.addressText += res.data.region.areaName
              }
            }
            vm.$refs['w-dialog'].onShowDialog()
          })
      } else if (type === 'edit') {
        vm.handleEdit()
        vm.$refs['w-dialog'].onShowDialog()
      } else if (type === 'add') {
        vm.dialogTitle = '添加账号'
        vm.sureBtnText = '添加'
        vm.cancelButtonText = '取消'
        vm.isShowFooter = true
        vm.$refs['w-dialog'].onShowDialog()
      } else if (type === 'addRole') {
        vm.dialogTitle = '添加角色'
        vm.sureBtnText = '添加'
        vm.cancelButtonText = '取消'
        vm.isShowFooter = true
        vm.$refs['w-dialog'].onShowDialog()
      } else if (['editRole', 'rolePromission'].includes(type)) {
        vm.handleEditRole()
        return false
      }
    },
    handleEdit() {
      this.dialogTitle = '修改账号'
      this.sureBtnText = '保存'
      this.form.userName = this.detail.username
      this.form.name = this.detail.name
      this.form.phone = this.detail.phone
      this.form.company = this.detail.company
      this.form.roleId = this.detail.roleId
      this.form.areaId = this.detail.areaId
      this.form.unavailableTime = new Date(this.detail.unavailableTime)
      this.form.idcardUrl = this.detail.idcardUrl
      this.form.idcardBackUrl = this.detail.idcardBackUrl
      this.form.bikeType = this.detail.bikeType
    },
    handleEditRole() {
      const vm = this
      const params = {
        selfAreaId: this.selfAreaId,
        roleId: this.detail.id
      }
      Api.getPermissionByRoleId(params)
        .then(res => {
          if (res.code === 200) {
            vm.detail.permissionIds = res.data
            vm.dialogTitle = '编辑角色'
            vm.sureBtnText = '保存'
            vm.cancelButtonText = '取消'
            vm.isShowFooter = true
            vm.formRole.name = vm.detail.name
            vm.formRole.level = vm.detail.level
            vm.formRole.description = vm.detail.description
            vm.formRole.isAudit = Number(vm.detail.isAudit) === 1
            if (vm.detail.permissionIds && vm.detail.permissionIds.length) {
              const len = vm.detail.permissionIds.length
              for (let i = 0; i < len; i++) {
                if (vm.permissions[i] && vm.permissions[i].child && vm.permissions[i].child.length) {
                  const allIds = []
                  vm.permissions[i].child.forEach(item => {
                    allIds.push(item.id)
                  })
                  vm.formRole['role-' + i] = vm.getSameArr(allIds, vm.detail.permissionIds)
                } else {
                  vm.formRole['role-' + i] = []
                }
              }
            }
            vm.$refs['w-dialog'].onShowDialog()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    getSameArr(allIds, selIds) {
      const res = []
      for (const it of allIds) {
        if (selIds.includes(it)) {
          res.push(it)
        }
      }
      return res
    },
    onSure() {
      if (this.type === 'textList' && this.pageType === 'systemSettings') {
        this.handleClose()
      } else if (this.type === 'textList' && this.pageType === 'auditListSettings') {
        this.handleAuditResolve()
        this.handleClose()
        location.reload() // 刷新页面
      } else if (['edit', 'add'].includes(this.type)) {
        this.handleForm()
      } else if (['editRole', 'addRole', 'rolePromission'].includes(this.type)) {
        this.handleFormRole()
      }
    },
    handleAuditResolve() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        id: this.detail.id,
        status: 1
      }
      Api.audit(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('账号审核通过成功！')
            vm.isShowFooter = false
            vm.detail.status = 1
            vm.detail.updateTime = res.data.updateTime
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    handleForm() {
      // 给时间加个默认值
      if (!this.form.unavailableTime) {
        this.form.unavailableTime = new Date('2031-04-30 23:59:59')
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (['edit'].includes(this.type)) {
            this.sysUserEdit()
          } else if (['add'].includes(this.type)) {
            this.sysUserAdd()
          }
        } else {
          return false
        }
      })
    },
    sysUserEdit() {
      const vm = this
      vm.btnLoading = true
      vm.form.id = vm.detail.id
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = vm.form
      data.unavailableTime = new Date(vm.form.unavailableTime).getTime()
      Api.sysUserEdit(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('用户编辑成功！')
            setTimeout(() => {
              vm.initData()
            }, 1000)
            vm.handleClose()
          } else {
            vm.$message.warning(res.message)
          }
          vm.btnLoading = false
        })
        .catch(err => {
          console.log(err)
          vm.btnLoading = false
        })
    },
    sysUserAdd() {
      const vm = this
      vm.btnLoading = true
      const params = {
        selfAreaId: vm.globaleSelfAreaId // vm.form.areaId
      }
      const data = vm.form
      data.unavailableTime = new Date(vm.form.unavailableTime).getTime()
      Api.sysUserAdd(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('用户添加成功！')
            setTimeout(() => {
              vm.initData()
            }, 1000)
            vm.handleClose()
          } else {
            vm.$message.warning(res.message)
          }
          vm.btnLoading = false
        })
        .catch(err => {
          console.log(err)
          vm.btnLoading = false
        })
    },
    handleFormRole() {
      this.$refs.roleForm.validate((valid) => {
        if (valid) {
          if (['editRole', 'rolePromission'].includes(this.type)) {
            this.handleApiEditRole()
          } else if (['addRole'].includes(this.type)) {
            this.handleApiAddRole()
          }
        } else {
          return false
        }
      })
    },
    handleApiEditRole() {
      const vm = this
      const data = this.getParams()
      const params = {
        selfAreaId: this.selfAreaId
      }
      data.id = this.detail.id
      Api.roleEdit(data, params)
        .then(res => {
          if (res.code === 200) {
            if (this.type === 'editRole') {
              vm.$message.success('角色编辑保存成功！')
            } else if (this.type === 'rolePromission') {
              vm.$message.success('角色权限设置保存成功！')
            }
            vm.initRole()
            vm.handleClose()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    handleApiAddRole() {
      const vm = this
      const data = this.getParams()
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.roleAdd(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('角色添加成功！')
            vm.initRole()
            vm.handleClose()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    getParams() {
      const obj = {}
      obj.name = this.formRole.name
      obj.phone = this.formRole.phone
      obj.description = this.formRole.description
      obj.isAudit = this.formRole.isAudit ? 1 : 2
      obj.level = this.formRole.level
      obj.permissionIds = []
      const len = this.permissions.length
      for (let i = 0; i < len; i++) {
        const select = this.formRole['role-' + i]
        if (select && select.length) {
          obj.permissionIds = obj.permissionIds.concat([...select, this.permissions[i].permission.id])
        }
      }
      return obj
    },
    handleCloseRight() {
      if (this.pageType === 'auditListSettings') {
        this.handleCloseBtn()
      } else {
        this.handleClose(true)
      }
    },
    handleClose(bo) {
      if (bo) {
        let textTitle = ''
        let text = ''
        if (['addRole'].includes(this.type)) {
          textTitle = '温馨提示'
          text = '你是否确定取消“角色”的添加？'
        } else if (['editRole'].includes(this.type)) {
          textTitle = '温馨提示'
          text = '你是否确定取消“角色”的编辑？'
        } else if (['rolePromission'].includes(this.type)) {
          textTitle = '温馨提示'
          text = '你是否确定取消“角色”的权限设置？'
        } else if (['add'].includes(this.type)) {
          textTitle = '温馨提示'
          text = '你是否确定取消本次账号添加？'
        } else if (['edit'].includes(this.type)) {
          textTitle = '温馨提示'
          text = '你是否确定取消本次修改？'
        } else if (['textList'].includes(this.type) && this.pageType === 'auditListSettings') {
          this.handleAuditReject()
          return null
        }
        if (textTitle) {
          this.$confirm(text, textTitle, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleCloseBtn()
          }).catch(() => {})
        } else {
          this.handleCloseBtn()
        }
      } else {
        this.handleCloseBtn()
      }
    },
    handleAuditReject() {
      const vm = this
      vm.$prompt('', '拒绝原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入拒绝原因'
      }).then(({ value }) => {
        console.log(value)
        vm.handleAuditRejectApi(value)
      }).catch(() => {
        console.log('取消输入')
      })
    },
    handleAuditRejectApi(value) {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        id: this.detail.id,
        status: 2,
        reason: value
      }
      Api.audit(data, params)
        .then(res => {
          if (res.code === 200) {
            vm.detail.reason = value
            vm.detail.status = 2
            vm.detail.updateTime = res.data.updateTime
            vm.isShowFooter = false
            vm.$message.success('账号审核拒绝过成功！')
            vm.$refs['w-dialog'] && this.$refs['w-dialog'].onCloseDialog()
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    handleCloseBtn() {
      this.detail = null
      this.type = ''
      this.dialogTitle = ''
      this.form.userName = ''
      this.form.name = ''
      this.form.phone = ''
      this.form.company = ''
      this.form.roleId = ''
      this.form.areaId = ''
      this.form.unavailableTime = ''
      this.form.idcardUrl = ''
      this.form.idcardBackUrl = ''

      this.formRole.name = ''
      this.formRole.level = ''
      this.formRole.description = ''
      this.formRole.isAudit = false
      this.areaIds = []
      this.formRole['role-0'] = []
      this.formRole['role-1'] = []
      this.formRole['role-2'] = []
      this.formRole['role-3'] = []
      this.formRole['role-4'] = []
      this.formRole['role-5'] = []
      this.formRole['role-6'] = []
      this.formRole['role-7'] = []

      this.isIndeterminate0 = true
      this.isIndeterminate1 = true
      this.isIndeterminate2 = true
      this.isIndeterminate3 = true
      this.isIndeterminate4 = true
      this.isIndeterminate5 = true
      this.isIndeterminate6 = true
      this.isIndeterminate7 = true
      this.checkAll0 = false
      this.checkAll1 = false
      this.checkAll2 = false
      this.checkAll3 = false
      this.checkAll4 = false
      this.checkAll5 = false
      this.checkAll6 = false
      this.checkAll7 = false

      this.$refs['w-dialog'] && this.$refs['w-dialog'].onCloseDialog()
    },
    pageNoChange(page) {
      if (this.pageType === 'systemSettings') {
        this.formData.pageNum = page
        this.initData()
      } else if (this.pageType === 'auditListSettings') {
        this.formDataAudit.pageNum = page
        this.initAuditData()
      }
    },
    pageSizeChange(size) {
      if (this.pageType === 'systemSettings') {
        this.formData.pageSize = size
        this.initData()
        store.commit('user/setUserInfo', {
          key: 'userCurrentPage',
          value: size
        })
      } else if (this.pageType === 'auditListSettings') {
        this.formDataAudit.pageSize = size
        this.initAuditData()
      }
    },
    pageNoChangeRole(page) {
      this.formDataRole.pageNum = page
      this.initRole()
    },
    pageSizeChangeRole(size) {
      this.formDataRole.pageSize = size
      this.initRole()
    },
    // 脱敏手机号码
    hidePhoneNumber(phoneNumber) {
      // 假设电话号码是11位的
      return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(7)
    },
    handleBikeType(type) {
      switch (type) {
        case 0:
          return '自行车'
        case 1:
          return '电动车'
        case 2:
          return '包含自行车和电动车'
      }
    }
  }
}
</script>

<style lang="less">
.layout.system-setting-layout {
  margin-top: 112px;
}
.system-setting {
  background:rgba(240,242,245,1);
  width: 100%;
  height: 100%;
  // overflow-y: scroll;
}
.dialog-content {
  .content-header{
    padding-bottom: 16px;
    border-bottom: 1px solid #EBEBEB;
    .title {
      font-size:20px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:bold;
      color:rgba(0,0,0,0.85);
      margin-bottom: 16px;
    }
    .author {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      color:rgba(0,0,0,0.45);
      span {
        margin-right: 32px;
      }
    }
  }
  .content-body {
    padding: 16px 0;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    color:rgba(0,0,0,0.45);
  }
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 21px;
    color: #8c939d;
    width: 112px;
    height: 112px;
    line-height: 112px;
    text-align: center;
    color: rgba(0,0,0,0.25);
  }
  .avatar-uploader-text {
    position: absolute;
    bottom: 18px;
    left: 39px;
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .avatar {
    width: 112px;
    height: 112px;
    display: block;
  }
  .breadcrumb-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f0f2f5;
    padding: 16px 30px 0 16px;
  }
  .breadcrumb {
    background-color: #f0f2f5;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    color:rgba(0,0,0,0.45);
    .last{
      color:rgba(0,0,0,0.85);
    }
    span {
      cursor: pointer;
    }
  }
</style>
